export default {
    parent: 'ApplicationLayout',
    template: `
        <div class="test-wrapper">
            <div class="col00">
                <ui-view class="body-wrapper"></ui-view>
            </div>
        </div>
        <footer class="footer-wrapper"></footer>
    `
};



// WEBPACK FOOTER //
// ./src/app/layouts/quiz/index.js